import { parseWorkflowEpisode } from './_pure/episode';
import { resolveWorkflowEpisode, resolveWorkflowScenePlan } from './episodeCatalog';
import { workflowVisualSources } from './visualSourceCatalog';
import type { EpisodeSupport } from '@/_contract/episodeSupport';
import type { CosmosDataModel } from '../../_contract/cosmosData';
import type { Config } from './_contract/config';
import type { WorkflowEpisode, WorkflowScene } from './_contract/episode';
import type { RuntimeState } from './_contract/runtime';

export const workflowEpisodeSupport = {
    parseEpisode: (value: unknown) => parseWorkflowEpisode(value, workflowVisualSources),
    resolveScene: resolveWorkflowEpisode,
    concept: { effectKinds: ['emphasis'] },
    trace: {
        effectKinds: ['emphasis'],
        visualPresentation: true,
        actionStartCues: false,
        excerpts: true,
        resolve: (args) => resolveWorkflowScenePlan(args.cosmosData, args.runtimeState, args.handle, args.sceneIndex),
    },
} satisfies EpisodeSupport<Config, RuntimeState, CosmosDataModel, WorkflowEpisode, WorkflowScene>;
